/* eslint-disable no-constant-condition */

import { call, put, take, fork, all } from 'redux-saga/effects';

import * as types from 'constants/ActionTypes';
import * as actions from 'actions';

import * as api from 'services/api';

const {
  chargers,
  chargersNearUser,
  chargersNearUserNext,
  places,
  cachedChargers,
  chargersNearIp,
  chargerReviews,
  chargerImages,
  placeReviews,
  chargerPlaces,
  user,
  users,
  currentUser,
  login,
  logout,
  countries,
  states,
  chargersRanked } = actions;


function* callAPI(endpoint, action, args) {
  const { response, error } = yield call(endpoint, ...args);
  if (response) {
    yield put(action.success(...args, response));
  } else {
    yield put(action.failure(...args, error));
  }
}

function* watchFetchChargers() {
  while (true) {
    const { args } = yield take(types.FETCH_CHARGERS);
    yield fork(callAPI, api.fetchChargers, chargers, [args]);
  }
}

function* watchChargersNearUser() {
  while (true) {
    const { args } = yield take(types.CHARGERS_NEAR_USER.REQUEST);
    yield fork(callAPI, api.fetchChargers, chargersNearUser, [args]);
  }
}

function* watchChargersNearUserNext() {
  while (true) {
    const { endpoint } = yield take(types.CHARGERS_NEAR_USER_NEXT.REQUEST);
    yield fork(callAPI, api.callApi, chargersNearUserNext, [endpoint]);
  }
}

function* watchFetchPlaces() {
  while (true) {
    const { args } = yield take(types.PLACES.REQUEST);
    yield fork(callAPI, api.fetchPlaces, places, [args]);
  }
}

function* watchChargersRanked() {
  while (true) {
    yield take(types.CHARGERS_RANKED.REQUEST);
    yield fork(callAPI, api.fetchRankedChargers, chargersRanked, []);
  }
}

function* watchFetchCachedChargers() {
  while (true) {
    const { url } = yield take(types.CACHED_CHARGERS.REQUEST);
    yield fork(callAPI, api.fetchCachedChargers, cachedChargers, [url]);
  }
}

function* watchFetchChargersNearIp() {
  while (true) {
    yield take(types.FETCH_CHARGERS_NEAR_IP);
    yield fork(callAPI, api.fetchChargersNearIp, chargersNearIp, []);
  }
}

function* watchChargerReviews() {
  while (true) {
    const { charger } = yield take(types.CHARGER_REVIEWS.REQUEST);
    yield fork(callAPI, api.fetchChargerReviews, chargerReviews, [charger]);
  }
}

function* watchChargerImages() {
  while (true) {
    const { charger } = yield take(types.CHARGER_IMAGES.REQUEST);
    yield fork(callAPI, api.fetchChargerImages, chargerImages, [charger]);
  }
}

function* watchPlaceReviews() {
  while (true) {
    const { place } = yield take(types.PLACE_REVIEWS.REQUEST);
    yield fork(callAPI, api.fetchPlaceReviews, placeReviews, [place]);
  }
}

function* watchChargerPlaces() {
  while (true) {
    const { charger, args } = yield take(types.CHARGER_PLACES.REQUEST);
    yield fork(callAPI, api.fetchChargerPlaces, chargerPlaces, [charger, args]);
  }
}

function* watchUserRequest() {
  while (true) {
    const { username } = yield take(types.USER.REQUEST);
    yield fork(callAPI, api.fetchUser, user, [username]);
  }
}

function* watchUsersRequest() {
  while (true) {
    const { args } = yield take(types.USERS.REQUEST);
    yield fork(callAPI, api.fetchUsers, users, [args]);
  }
}

function* watchCurrentUserRequest() {
  while (true) {
    yield take(types.CURRENT_USER.REQUEST);
    yield fork(callAPI, api.fetchCurrentUser, currentUser, []);
  }
}

function* watchLogin() {
  while (true) {
    const { username, password } = yield take(types.LOGIN.REQUEST);
    yield call(callAPI, api.login, login, [username, password]);
  }
}

function* watchLogout() {
  while (true) {
    yield take(types.LOGOUT.REQUEST);
    yield call(callAPI, api.logout, logout, []);
  }
}

function* watchFetchCountries() {
  while (true) {
    yield take(types.COUNTRIES.REQUEST);
    yield call(callAPI, api.fetchCountries, countries, []);
  }
}

function* watchFetchStates() {
  while (true) {
    yield take(types.STATES.REQUEST);
    yield call(callAPI, api.fetchStates, states, []);
  }
}

export default function* rootSaga() {
  yield all([
    watchFetchChargers(),
    watchChargersNearUser(),
    watchChargersNearUserNext(),
    watchFetchPlaces(),
    watchChargersRanked(),
    watchFetchCachedChargers(),
    watchFetchChargersNearIp(),
    watchChargerReviews(),
    watchChargerImages(),
    watchPlaceReviews(),
    watchChargerPlaces(),
    watchUserRequest(),
    watchUsersRequest(),
    watchCurrentUserRequest(),
    watchLogin(),
    watchLogout(),
    watchFetchCountries(),
    watchFetchStates(),
  ]);
}



// WEBPACK FOOTER //
// ./app/scripts/sagas/index.js